import { VendorBilled }               from './vendors.vendor-billed.directive';
import { VendorBilledCtrl }           from './vendors.vendor-billed';
import { VendorBranchPaymentCtrl }    from './vendor.branch-payment';
import { VendorCtrl }                 from './vendor';
import { VendorInvoices }             from './vendors.vendor-invoices.directive';
import { VendorOrders }               from './vendors.vendor-orders.directive';
import { VendorOrdersCtrl }           from './vendors.vendor-orders';
import { VendorPaymentCtrl }          from './vendor-payment';
import { VendorPayments }             from './vendors.vendor-payments.directive';
import { VendorPaymentsCtrl }         from './vendors.vendor-payments';
import { VendorQuickAddCtrl }         from './vendor.quick-add';
import { VendorsCtrl }                from './vendors';
import { VendorService }              from './vendor.service';
import { VendorsStates }              from './vendors.states.ajs';

angular.module('workshop.vendors', [])

.controller('VendorBilledCtrl',         VendorBilledCtrl)
.controller('VendorBranchPaymentCtrl',  VendorBranchPaymentCtrl)
.controller('VendorCtrl',               VendorCtrl)
.controller('VendorOrdersCtrl',         VendorOrdersCtrl)
.controller('VendorPaymentCtrl',        VendorPaymentCtrl)
.controller('VendorPaymentsCtrl',       VendorPaymentsCtrl)
.controller('VendorQuickAddCtrl',       VendorQuickAddCtrl)
.controller('VendorsCtrl',              VendorsCtrl)

.factory('Vendor',                      VendorService)

.directive('vendorBilled',              VendorBilled)
.directive('vendorInvoices',            VendorInvoices)
.directive('vendorOrders',              VendorOrders)
.directive('vendorPayments',            VendorPayments)

.config(VendorsStates);